import React from 'react';
import { Carousel } from 'react-bootstrap';
import './QuestionCarousel.css';

const QuestionCarousel = ({
  questions = [],
  answers = [],
  onAnswerChange,
  onSubmit,
  showResults = false,
  customIcons = true,
  submitLabel = "Check Answer",
  className = "",
  carouselProps = {},
  containerClassName = ""
}) => {
  if (!questions.length) return null;

  const isCorrect = (qIdx, choice) => {
    const question = questions[qIdx];
    return choice === question.correctAnswer;
  };

  const getResultIcon = (qIdx, cIdx, choice) => {
    if (!showResults) return null;
    const question = questions[qIdx];
    const correct = question.correctAnswer;
    const isChosen = answers[qIdx] === choice;
    if (isChosen && choice === correct) {
      return <span className="result-icon correct">&#10003;</span>;
    } else if (isChosen && choice !== correct) {
      return <span className="result-icon incorrect">&#10005;</span>;
    }
    return null;
  };

  const CustomPrevIcon = () => (
    <span className="custom-carousel-control custom-carousel-prev" aria-label="Previous">
      <span className="carousel-arrow">&#8249;</span>
    </span>
  );

  const CustomNextIcon = () => (
    <span className="custom-carousel-control custom-carousel-next" aria-label="Next">
      <span className="carousel-arrow">&#8250;</span>
    </span>
  );

  return (
    <div className={`question-carousel-container ${containerClassName}`}>
      <form onSubmit={onSubmit} className={`question-carousel-form ${className}`}>
        <Carousel
          interval={null}
          wrap={false}
          controls={customIcons}
          indicators={false}
          prevIcon={customIcons ? <CustomPrevIcon /> : undefined}
          nextIcon={customIcons ? <CustomNextIcon /> : undefined}
          className="question-carousel"
          {...carouselProps}
        >
          {questions.map((q, qIdx) => (
            <Carousel.Item key={qIdx}>
              <div className="question-carousel-item">
                <div className="question-text">
                  {q.number}. {q.question}
                </div>
                <div className="choices-container">
                  {q.choices?.map((choice, cIdx) => (
                    <label key={cIdx} className="choice-label">
                      <input
                        type="radio"
                        value={choice}
                        checked={answers[qIdx] === choice}
                        onChange={() => onAnswerChange?.(qIdx, choice)}
                        className="choice-radio"
                      />
                      <span className="choice-text">{choice}</span>
                      {getResultIcon(qIdx, cIdx, choice)}
                    </label>
                  ))}
                </div>
                <button type="submit" className="checkbtn">
                  {submitLabel}
                </button>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </form>
    </div>
  );
};

export default QuestionCarousel;